import { Action, applyMiddleware, createStore as originalCreateStore, Store, Middleware } from 'redux';
import sagaMiddlewareFactory from 'redux-saga';
import { enableBatching } from 'redux-batched-actions';

import { CheckoutState, rootReducer } from './reducers';
import rootSaga from './sagas';
import memes from '../../memes';
import { useConfig } from '../../context';

export const createStore = memes(
	(): Store<CheckoutState> => {
		const saga = sagaMiddlewareFactory({
			context: {
				config: useConfig()
			}
		});
		const middleware: Middleware[] = [saga];

		if (process.env.NODE_ENV === 'development') {
			middleware.push(require('redux-logger').default);
		}

		const store = originalCreateStore<CheckoutState, Action, {}, {}>(
			enableBatching(rootReducer),
			applyMiddleware(...middleware)
		);

		saga.run(rootSaga);

		return store;
	}
);
